'use client';

import { useAuthBoot } from '../context/AuthBootContext';
import { cn } from '@/lib/utils/cn';
import { resolveLoginLogoUrl } from '../utils/logo';

enum ELogoSize {
    SMALL = 'small',
    LARGE = 'big',
}

export function Logo(): React.ReactElement {
    const { authBoot } = useAuthBoot();

    const logoSrc = resolveLoginLogoUrl(authBoot);
    const loginLogoSize = authBoot.storeTheme.login?.loginLogoSize;
    const isLarge = loginLogoSize === ELogoSize.LARGE;
    // Height-only reservation matches prior design (w-auto). Explicit attrs +
    // !important height fight globals.css `img { height: unset }` without
    // forcing a square crop box that would change wide logos.
    const heightPx = isLarge ? 192 : 120;
    const heightPxLg = isLarge ? 200 : 128;

    return (
        <div
            className="relative mx-auto mb-5 mt-5 flex w-full items-center justify-center"
            data-testid="login-logo"
            style={{ height: heightPx, minHeight: heightPx }}
        >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                className={cn(
                    'object-contain max-w-full !w-auto',
                    isLarge
                        ? '!h-[192px] !max-h-[192px] lg:!h-[200px] lg:!max-h-[200px]'
                        : '!h-[120px] !max-h-[120px] lg:!h-[128px] lg:!max-h-[128px]',
                )}
                alt="game logo"
                src={logoSrc}
                width={heightPxLg}
                height={heightPxLg}
                fetchPriority="high"
                decoding="sync"
                style={{ height: heightPx, width: 'auto', maxHeight: heightPx }}
            />
        </div>
    );
}
